import { useParams } from "react-router-dom";
import ConsentBuilder from "./Builder/ConsentBuilder";
import { useQuery } from "../../utils/hooks";

const StudyConsentBuilder = () => {
  const { id: studyId, formId } = useParams();
  const versionId = useQuery().get("versionId") || "";
  const formType = useQuery().get("formType") || "";

  return (
    <ConsentBuilder
      studyId={studyId || ""}
      formId={formId || ""}
      versionId={versionId}
      type="study"
      editable={true}
      formType={formType as "consent" | "sunshine"}
    />
  );
};

export default StudyConsentBuilder;
